/**
 * Created by dushyantha on 7/21/16.
 */
'use strict';

(function () {
  angular
    .module('crewSchedule')
    .component('userDetailsComponent', {
      templateUrl: 'crew-schedule/components/user-details-component.tpl.html',
      controller: function (EventManagerService,CrewingHelper,CommonMasterData,MessageService,PopupManager, $scope, RemoteService) {
        var vm = this;

        vm.nameColor = '#0D509C'; //setting the name color to default value
        vm.nameColorRed = '#ff0000' //for setting the color of the name red in user details
        vm.imgNotFound = false;
        vm.oneAtATime = false;
        vm.status = {
          isFirstOpen: false,   //no comment
          isFirstDisabled: false,
          isNoteOpen:false,
          isSecondOpen:false,
          fourthOpen:false,
          fifthOpen:false,
          sixthOpen:false,
          isSevenOpen:false,
          isFlightData:false,
          isBlockData:true,
          isTakeOffLandingData:false,
          isAvailableTrainings: true,
          isTrainingDetails: false
        };

        vm.noteErrors={};
        vm.noteErrors.isRemarkEmpty=false;
        vm.noteErrors.fromDateEmpty=false;
        vm.noteErrors.toDateEmpty=false;
        vm.allResults= [{name: 'PASS'}, {name: 'FAIL'}];
        vm.allModules= [];
        vm.allCourses= [];
        vm.crewRoleCol= [];
        vm.selectedCrewList = [];
        vm.selectedCrew = null;
        vm.crewProfileIds = [];
        vm.crewIds = [];
        vm.crewProfileIdToTypeMap = {};
        vm.crewHubs = [];
        vm.isAllCrewSelected = false;

        vm.checkIntimeReset = false;
        vm.checkInDateStr = null;
        vm.checkInTimeStr = null;
        vm.showingCrewProfile = true;

        vm.showTrainingPassPanel = false;
        vm.selectedTrainingSlotId = null;
        vm.selectedFlightLegIdList = [];
        vm.selectedTrainingSlotIdList = [];
        vm.startTimeTraining = null;
        vm.warnings = [];
        vm.crewBatchAttributes = [];

        function tabCntrl() {
          vm.tab = 1;
        }

        $scope.$on('onBlockDetailsChange', function(event) {
          vm.status.isFirstOpen = true;
          vm.status.isSecondOpen = false;
          vm.status.fourthOpen = false;
          vm.status.fifthOpen = false;
          vm.status.sixthOpen = false;
          vm.status.isSevenOpen = false;
        });

        function onPanelDataChange() {
          vm.status.fourthOpen =true;
          vm.status.isNoteOpen=false;
        //  vm.status.isFirstOpen = false;
          vm.status.isSecondOpen= false;
          vm.status.fifthOpen= false;
          vm.status.sixthOpen= false;
          vm.status["isAvailableTrainings"] = true;
          vm.status["isTrainingDetails"] = false;
          vm.status.isSevenOpen= false;

          vm.isTrainerTraineeDisable = true;

          vm.selectedCrewRole = false;
          vm.isExpiryUpdatable = false;

          if (typeof vm.blockDetails.blockType === 'undefined') {
            vm.status.isFirstOpen = true;
            vm.status.fourthOpen = true;
            vm.status["isAvailableTrainings"] = true;
            vm.status["isTrainingDetails"] = false;
            // vm.status.sixthOpen =true;
          }

          else if (vm.blockDetails.isTraining) {
//            vm.selectedTrainingSlotId = vm.selectedFlightLegId = vm.blockDetails.adaptedFlightEventDetails &&
//              vm.blockDetails.adaptedFlightEventDetails[0] &&
//              vm.blockDetails.adaptedFlightEventDetails[0].id;
            vm.selectedTrainingSlotId = vm.blockDetails.scheduleTrainingDetails[0].trainingSlotId;
            vm.isTrainingProgramDisable = true;
            vm.status.isFirstOpen = false;
            vm.status.fourthOpen = false;
            vm.status.sixthOpen = true;
            vm.status["isAvailableTrainings"] = false;
            vm.status["isTrainingDetails"] = true;
            populateFlightLegList();
            updateSelectedType();
            // scrollToBlockDetails();
          } else {
            vm.selectedFlightLegId = vm.blockDetails.adaptedFlightEventDetails &&
              vm.blockDetails.adaptedFlightEventDetails[0] &&
              vm.blockDetails.adaptedFlightEventDetails[0].id;
            vm.isTrainingProgramDisable = false;
            vm.status.isFirstOpen = false;
            vm.status.fourthOpen = true;
            populateFlightLegList();
            updateSelectedType();
            // FLIGHT  EVENT
            vm.status.sixthOpen = true;
            if (vm.blockDetails.blockType === "EVENT"){
              vm.status["isAvailableTrainings"] = true;
              vm.status["isTrainingDetails"] = false;
            }else{
              vm.status["isAvailableTrainings"] = false;
              vm.status["isTrainingDetails"] = true;
            }
            scrollToBlockDetails();
          }

          vm.selectedCrewProfileId =   vm.blockDetails && vm.blockDetails.adaptedAssignedCrewDetails &&
            vm.blockDetails.adaptedAssignedCrewDetails[0] &&
            vm.blockDetails.adaptedAssignedCrewDetails[0].crewProfileId;

          if (!!vm.selectedFlightLegId || !!vm.selectedTrainingSlotId) {
            getTrainings();
          }
          // getTrainings();
          vm.selectedCrewList = [];
        }

        function populateFlightLegList(){
          vm.selectedFlightLegIdList = [];
          for(var i = 0;i<vm.blockDetails.scheduleFlightLegDetails.length;i++){
            if(vm.blockDetails.scheduleFlightLegDetails[i].trainingProgramId != null){
              vm.selectedFlightLegIdList.push(vm.blockDetails.scheduleFlightLegDetails[i].flightLegId);
            }
          }
          vm.selectedTrainingSlotIdList = [];
          for(var i = 0;i<vm.blockDetails.scheduleTrainingDetails.length;i++){
            if(vm.blockDetails.scheduleTrainingDetails[i].trainingSlotId != null){
              vm.selectedTrainingSlotIdList.push(vm.blockDetails.scheduleTrainingDetails[i].trainingSlotId);
            }
          }
        }

        function updateSelectedType(){
          if(vm.blockDetails.scheduleFlightLegDetails.length > 0 && vm.blockDetails.scheduleTrainingDetails.length == 0){
            vm.selectedType = 'FLIGHT';
          }else if(vm.blockDetails.scheduleFlightLegDetails.length == 0 && vm.blockDetails.scheduleTrainingDetails.length > 0){
            vm.selectedType = 'TRAINING';
          }
        }

        EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_FLIGHT_UPDATE, updateTakeOffLandingDetailAfterTraingChange);

        function updateTakeOffLandingDetailAfterTraingChange(response){
          vm.blockDetails.takeOffLandingDetails = response.scheduleBlockDetail.takeOffLandingDetails;
          vm.blockDetails.takeOffLandingUpdateEnable = response.scheduleBlockDetail.takeOffLandingUpdateEnable;
        }

        function scrollToBlockDetails() {
          console.log("scrollToBlockDetails()");
          var main = document.getElementById("crew_details_block");
          // var main = document.getElementById("flight_block_details");
          console.log(main);
          // main.scrollTop = 200;
          // main.scrollHeight/2
          // main.scrollIntoView();
          var flight_block = document.getElementById("flight_block_details");
          console.log(flight_block);
          flight_block.focus();
          // $(flight_block).scrollTop( 300 );
        }

        function getTrainings() {
          vm.trainingPrograms = [];
          if (vm.blockDetails.scheduleTrainingDetails.length > 0) {
            var selected = _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: vm.selectedTrainingSlotId});
            if (!!selected) {
              vm.trainingPrograms.push({
                trainingProgCode: selected.trainingProgramCode,
                trainingProgramId: selected.trainingProgramId
              });
              vm.selectedTrainingProgram = vm.trainingPrograms[0];
              getTrainingProgramDetails();
            }
          }
          if (vm.blockDetails.scheduleFlightLegDetails.length > 0) {
            CrewingHelper.getTrainingProgramsByCategoryCode('FLT',
              function (trainings) {
                for (var i = 0; i < trainings.length; i++) {
                  vm.trainingPrograms.push(trainings[i]);
                }
                setSelectedTraining();
              },
              function (msg) {
                MessageService.error(msg);
              }
            );
          }
        }

        function setPassFailInfo(){
          var selected;
          if(vm.blockDetails.isTraining){
            selected = _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: vm.selectedTrainingSlotId});
          }else {
            selected = _.find(vm.blockDetails.scheduleFlightLegDetails, {flightLegId: vm.selectedFlightLegId});
          }

          if(!!selected){
            vm.isExpiryUpdatable =  selected.expiryUpdatable;
            var crew = _.find(selected.assignedCrewTrainingDetails,{crewProfileId : vm.selectedCrewProfileId});
            if(!!crew && crew.result){
              vm.selectedResult = {name : crew.result};
              vm.validationNo = crew.validationNo;
              vm.remarks = crew.remarks;
            }else{
              vm.selectedResult = null;
              vm.validationNo = null;
              vm.remarks = null;
            }
          }
        }

        function setRoleForSelectedCrew(){
          var crew = _.find(vm.blockDetails.assignedCrewDetailDTOs,{crewProfileId : vm.selectedCrewProfileId});
          vm.selectedCrewRole = null;

          if(!!crew && !!crew.trainrerTraineeType){
        	vm.selectedCrewRole = _.find(vm.crewRoleCol,{trainerTypeCode : crew.trainrerTraineeTypeCode});
            if(crew.trainrerTraineeTypeCode == 'TNE') {
            	vm.showTrainingPassPanel = true;
            	setPassFailInfo();
            }
          }
        }

        function setCourseForSelectedCrew(){
          var crew = _.find(vm.blockDetails.assignedCrewDetailDTOs,{crewProfileId : vm.selectedCrewProfileId});
          vm.selectedCrewCourse = null;
          if(!!crew && !!crew.trainrerTraineeType){
            vm.selectedCrewCourse = _.find(vm.allCourses,{courseId : crew.courseName});
          }
        }


        function getTrainerTrainee() {
          if (vm.selectedTrainingSlotId == null) {
            vm.selectedTrainingSlotId = 0;
          }
          if (vm.startTimeTraining == null) {
            vm.startTimeTraining = "FLIGHT";
          }
          if (typeof vm.selectedTrainingProgram != 'undefined' && vm.selectedTrainingProgram != null) {
            if (!!vm.selectedCrewProfileId && !!vm.selectedTrainingProgram && vm.selectedTrainingProgram.trainingProgramId)
              var startTime = vm.startTimeTraining.toString().replace("/", "-").replace("/", "-");
            CommonMasterData.getTrainerTraineeTypes(
              vm.selectedCrewProfileId,
              vm.selectedTrainingProgram.trainingProgramId,
              vm.selectedTrainingSlotId,
              startTime,
              vm.selectedCrew.crewId,
              function (types) {
                vm.crewRoleCol = types;
                setRoleForSelectedCrew();
              },
              function (error) {
                MessageService.error(error);
              }
            )
          }
          else {
            vm.crewRoleCol = [];
            setRoleForSelectedCrew();
          }
        }

        function getTrainerTraineeCourses() {
          if (!!vm.selectedCrewProfileId && !!vm.selectedTrainingProgram && vm.selectedTrainingProgram.trainingProgramId)
            CommonMasterData.getTrainerTraineeCoursesForHub(
              vm.selectedCrewProfileId,
              vm.selectedTrainingProgram.trainingProgramId,
              vm.selectedCrew ? vm.selectedCrew.crewId : null,
              vm.selectedCrew ? vm.selectedCrew.otherHub : null,
              function (types) {
                vm.allCourses = types;
                setCourseForSelectedCrew();
              },
              function (error) {
                MessageService.error(error);
              }
            )
        }

        function setSelectedTrainingProgramDetails() {
          var selected;
          if(vm.blockDetails.isTraining){
            selected = _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: vm.selectedTrainingSlotId});
          }else{
            selected = _.find(vm.blockDetails.scheduleFlightLegDetails, {flightLegId: vm.selectedFlightLegId});
          }

          if (!!selected) {
            vm.selectedTrainingProgramDetails = _.find(vm.trainingProgramDetails, {trainingProgDetailCode: selected.subProgramCode});
            if (!!vm.selectedTrainingProgramDetails) {
              vm.isTrainerTraineeDisable = false;
              if(!!vm.selectedCrewProfileId){
                getTrainerTrainee();
                getTrainerTraineeCourses();
              }
            }
          }
          getTrainerTrainee();
        }

        function setSelectedTraining() {
          var selectedFlight = _.find(vm.blockDetails.scheduleFlightLegDetails, {flightLegId: vm.selectedFlightLegId});
          if (!!selectedFlight) {
            vm.selectedPic = (selectedFlight.isPIC ==='Y' ? true : false);
            vm.selectedFam = (selectedFlight.isFam ==='Y' ? true : false);
            vm.selectedTrainingProgram = _.find(vm.trainingPrograms, {trainingProgramId: selectedFlight.trainingProgramId});
            if (!!vm.selectedTrainingProgram) {
              getTrainingProgramDetails();
            } else {
              vm.selectedTrainingProgramDetails = null;
              vm.crewRoleCol =[];
              vm.allCourses =[];
            }
          }
        }

        function getTrainingProgramDetails() {
          if (!!vm.selectedTrainingProgram) {
            CommonMasterData.getTrainingProgramDetails(vm.selectedTrainingProgram,
              function (programDetails) {
                vm.trainingProgramDetails = programDetails;
                setSelectedTrainingProgramDetails();
              },
              function (msg) {
                MessageService.error(msg);
              })
          }else{
            vm.trainingProgramDetails = null;
            vm.selectedTrainingProgramDetails = null;
          }
        }
        vm.onTrainingChange = function () {
          getTrainingProgramDetails();
        };

        vm.imageUrlNotAccessible = function(){
          alert('img error');
          vm.imgNotFound = true;
        };

        vm.$onChanges = function (changeObj) {
          console.log("changeObj :", changeObj)
          if (changeObj.crewDetails && changeObj.crewDetails.currentValue && (changeObj.crewDetails.currentValue != changeObj.crewDetails.previousValue)) {
            adaptActualTimes();
            if (changeObj.crewDetails.currentValue.crewProfileId) {
              vm.crewBatchAttributes = [];
              RemoteService.getAssignedBatchesForCrew({ crewProfileIds: [changeObj.crewDetails.currentValue.crewProfileId], fromDate: vm.scheduleFromDate, toDate: vm.scheduleToDate }, false).then(
                function (response) {
                  if (response && response.batchList) {
                    vm.crewBatchAttributes = response.batchList.map(function (b) { return b.crewBatchCode; });
                  }
                },
                function () {
                  vm.crewBatchAttributes = [];
                }
              );
            }
          }
          if (changeObj.crewPublishSchedule && changeObj.crewPublishSchedule.currentValue && !angular.equals(changeObj.crewPublishSchedule.currentValue, changeObj.crewPublishSchedule.previousValue)) {
            adaptPublishTimes();
          }
          if (changeObj.blockDetails && changeObj.blockDetails.currentValue && changeObj.blockDetails.currentValue.crewScheduleBlockId && !angular.equals(changeObj.blockDetails.currentValue.crewScheduleBlockId, changeObj.blockDetails.previousValue.crewScheduleBlockId)) {
            // (changeObj.blockDetails.crewNotes != changeObj.blockDetails.previousValue)
            onPanelDataChange();
          }
          if (changeObj.crewNotes) {

            if(changeObj.crewNotes.currentValue !== null){

              vm.status.isNoteOpen=true;
              vm.status.isFirstOpen = false;
            }
            else{
              vm.status.isNoteOpen=false;
              vm.status.isFirstOpen = true;
            }

          }
        };
        //change actual schedule times to HH:MM format
        function adaptActualTimes(){
          if (vm.crewDetails.flyingDuration && !vm.crewDetails.flyingDuration.toString().includes(".")){
            vm.crewDetails.flyingDuration = getHours(vm.crewDetails.flyingDuration);
          }

          if (vm.crewDetails.dutyDuration && !vm.crewDetails.dutyDuration.toString().includes(".")){
            vm.crewDetails.dutyDuration = getHours(vm.crewDetails.dutyDuration);
          }

          if (vm.crewDetails.targetDuration && !vm.crewDetails.targetDuration.toString().includes(".")){
            vm.crewDetails.targetDuration= getHours(vm.crewDetails.targetDuration);
          }

          if (vm.crewDetails.totalCreditHours && !vm.crewDetails.totalCreditHours.toString().includes(".")){
            vm.crewDetails.totalCreditHours = getHours(vm.crewDetails.totalCreditHours);
          }

        }

        //change publish schedule times to HH:MM format
        function adaptPublishTimes(){

          if (vm.crewPublishSchedule.dutyDuration && !vm.crewPublishSchedule.dutyDuration.toString().includes(".")){
            vm.crewPublishSchedule.dutyDuration = vm.crewPublishSchedule.dutyDuration > 0 ? getHours(vm.crewPublishSchedule.dutyDuration): "";
          }

          if (vm.crewPublishSchedule.flyingDuration && !vm.crewPublishSchedule.flyingDuration.toString().includes(".")){
            vm.crewPublishSchedule.flyingDuration = vm.crewPublishSchedule.flyingDuration > 0 ? getHours(vm.crewPublishSchedule.flyingDuration): "";
          }

          //vm.crewPublishSchedule.dutyDuration = getHours(vm.crewPublishSchedule.dutyDuration);
        }

        function getHours(min){
          var h = Math.floor(min/60);
          var m = min%60;
          if(m<10){
            m = '0'+m;
          }
          var totalTime = h+'.'+m;
          return totalTime;
        }

        vm.addNewNotes = function(){
          if(!!vm.noteModel.fromDate && !!vm.noteModel.toDate && !!vm.noteModel.remark){
            vm.addEditNotes();
            vm.noteErrors.isRemarkEmpty=false;
            vm.noteErrors.fromDateEmpty=false;
            vm.noteErrors.toDateEmpty=false;
          }
          else{
            if(!vm.noteModel.fromDate){
              vm.noteErrors.fromDateEmpty=true;
            }
            if(!vm.noteModel.toDate){
              vm.noteErrors.toDateEmpty=true;
            }
            if(!vm.noteModel.remark){
              vm.noteErrors.isRemarkEmpty=true;
            }
          }

        };

        vm.editNote= function(note){
          vm.loadEditNoteData({'noteModel':note});
        };

        vm.deleteNote=function(note){
          vm.deleteCrewNotes({'note':note})
        };

        vm.remarkChange = function(){
          vm.noteErrors.isRemarkEmpty=false;
        };

        vm.noteFromDateChange = function(){
          vm.noteErrors.fromDateEmpty=false;
        };

        vm.noteToDateChange = function(){
          vm.noteErrors.toDateEmpty=false;
        };

        vm.onUpdateClick = function () {
          var flightStartDateTime = vm.blockDetails.adaptedFlightEventDetails[0].startTime;
          var flightEndDateTiem = vm.blockDetails.adaptedFlightEventDetails[vm.blockDetails.adaptedFlightEventDetails.length-1].endTime;
          if(moment(flightStartDateTime,"DD/MM/YYYY HH:mm").isBefore(moment(vm.blockDetails.checkInDateStr+" "+vm.blockDetails.checkInTimeStr,"DD/MM/YYYY HH:mm"))){
            MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_01);
            return false;
          }
          else if(moment(vm.blockDetails.checkoutDateStr+" "+vm.blockDetails.checkoutTimeStr,"DD/MM/YYYY HH:mm").isBefore(moment(flightEndDateTiem,"DD/MM/YYYY HH:mm"))){
            MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_02);
            return false;
          }
          else{
            onUpdate(false);
          }


        };

        vm.onTakeOffLandingUpdateClick = function () {
          CrewingHelper.updateTakeOffLanding(vm.blockDetails,
            function (res) {
              MessageService.success('Takeoff Landing successfully updated.');
            },
            function (error) {
              MessageService.error(error);
            }
          );


        };

        function onUpdate(isContinueIllegal) {
          vm.blockDetails.continueIllegal = isContinueIllegal;
          CrewingHelper.updateCheckInCheckout(vm.blockDetails,
            function (res) {
              editPairingResponseAction(res);
            },
            function (error) {
              MessageService.error(error);
            }
          );
        }

        function updateCheckInTime(isContinueIllegal) {
          vm.blockDetails.continueIllegal = isContinueIllegal;

          if(vm.checkInDateStr != null && vm.checkInTimeStr != null){
            vm.blockDetails.checkInDateStr = vm.checkInDateStr;
            vm.blockDetails.checkInTimeStr = vm.checkInTimeStr;
          }

          CrewingHelper.updateCheckInCheckout(vm.blockDetails,
            function (res) {
              editCheckDetailsResponseAction(res);
            },
            function (error) {
              MessageService.error(error);
            }
          );
        }

        function editCheckDetailsResponseAction(editParingResponse) {
          if (editParingResponse.success) {
            updateTrainerTrainee();
            if (editParingResponse.otherBlockIllegal) {
              MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
            }
          } else if (!!editParingResponse) {
            if (!!editParingResponse.regulationMap) {
              var regulationDetailParam = {
                regulationMap: editParingResponse.adaptedRegulationMap,
                onAcceptPassBackParam: editParingResponse
              };
              PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseheckDetailsResponseRegulationPopup);
            }
          }
        }

        function onCloseheckDetailsResponseRegulationPopup(params) {
          if (!!params) {
            updateCheckInTime(true);
          }
        }

        function updateTrainingDetails(continueOveride){
          // if (!!vm.selectedTrainingProgram && !!vm.selectedTrainingProgramDetails) {
          var crewSchdBlockId = vm.blockDetails.crewScheduleBlockId;
          var type = (vm.selectedType == 'TRAINING') ? 'SLOT' : 'FLIGHT';
          var slotId = (vm.selectedType == 'TRAINING') ? vm.selectedTrainingSlotId : vm.selectedFlightLegId;
          var selected;
          if (vm.selectedType == 'TRAINING') {
            selected = _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: vm.selectedTrainingSlotId});
          } else {
            selected = _.find(vm.blockDetails.scheduleFlightLegDetails, {flightLegId: vm.selectedFlightLegId});
          }
          var version = !!selected ? selected.version : 0;

          CrewingHelper.updateTrainingProgram(
            vm.blockDetails.blockId,
            vm.blockDetails.crewProfileId,
            continueOveride,
            vm.selectedPic ? 'Y' : 'N',
            crewSchdBlockId,
            type,
            slotId,
            !!vm.selectedTrainingProgram ? vm.selectedTrainingProgram.trainingProgramId : null,
            !!vm.selectedTrainingProgramDetails ? vm.selectedTrainingProgramDetails.trainingProgramDetailId : null,
            version,
            function (updateResponse) {
                if (updateResponse.success) {
                  if(updateResponse.picCrewList == null) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.REFRESH);
                    MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                    var updated = CrewingHelper.getCrewIdsFromBlockDetails(vm.blockDetails);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                    var updateSelected, updateActual;
                    if (vm.blockDetails.isTraining) {
                      updateSelected = _.find(vm.blockDetails.scheduleTrainingDetails, {id: vm.selectedTrainingSlotId});
                    } else {
                      updateSelected = _.find(vm.blockDetails.adaptedFlightEventDetails, {id: vm.selectedFlightLegId});
                      updateActual = _.find(vm.blockDetails.scheduleFlightLegDetails, {flightLegId: vm.selectedFlightLegId});
                    }
                    updateSelected.trainingPro = !!vm.selectedTrainingProgram ? vm.selectedTrainingProgram.trainingProgCode : null;
                    updateSelected.progDetails = !!vm.selectedTrainingProgramDetails ? vm.selectedTrainingProgramDetails.trainingProgDetailDesc : null;
                    updateSelected.pic = !!vm.selectedPic ? 'Y' : 'N';
                    updateSelected.fam = !!vm.selectedFam ? 'Y' : 'N';
                    selected.version++;
                  }
                  else{
                    picOveridePermission(updateResponse.picCrewList[0]);
                  }
                } else {
                  MessageService.error(MessageService.MESSAGES.CREWING.UPDATE_FAIL);
                }

            },
            function (msg) {
              MessageService.error(msg);
            },
            vm.selectedFlightLegIdList,
            vm.selectedFam ? 'Y' : 'N');
          // }
        }

        function picOveridePermission(picCrewList){
          var picCrewId = picCrewList.crewProfileID;
          var picCrewType = picCrewList.crewType;
          var picCrewName = picCrewList.crewName;
          var details = {
            title: 'PIC Crew alert',
            messages: [MessageService.MESSAGES.CREWING.PIC_CREW_EXIST+"\n Crew ID: "+picCrewId+"\n, Crew Name: "+picCrewName+", \nCrew Type: "+picCrewType]
          };
          PopupManager.openModal('CONFIRM_DIALOG', details, confirmPicOveride);

          function confirmPicOveride(param) {
            if(param === 'YES'){
              var continueOveride = true;
              updateTrainingDetails(continueOveride);
            }else {
              return false;
            }
          }

        }

        vm.onFlightClick = function (obj) {
            if (obj.type === 'EVENT') {
              vm.selectedFlightLegId = null;
              vm.selectedEventId = obj.id;
              vm.isTrainingProgramDisable = true;
              vm.trainingProgramDetails = null;
              vm.selectedTrainingProgram = null;
              vm.selectedPic = null;
              vm.selectedFam = null;
              vm.selectedTrainingProgramDetails = null;
            } else {
              vm.selectedType = obj.type;
              var index = -1;
              if(vm.selectedType === 'FLIGHT'){
                index = vm.selectedFlightLegIdList.indexOf(obj.id);
              }else if (vm.selectedType === 'TRAINING'){
                index = vm.selectedTrainingSlotIdList.indexOf(obj.id);
              }
              if(index === -1) {
                vm.isTrainingProgramDisable = false;
                if(vm.selectedType === 'FLIGHT'){
                  vm.selectedFlightLegIdList.push(obj.id);
                  vm.selectedFlightLegId = obj.id;
                }else if (vm.selectedType === 'TRAINING'){
                  vm.selectedTrainingSlotIdList.push(obj.id);
                  vm.selectedTrainingSlotId = obj.id;
                }
                vm.selectedEventId = null;
                vm.selectedTrainingProgram = _.find(vm.trainingPrograms, {trainingProgCode: obj.trainingPro});
                vm.selectedPic = obj.pic == 'Y' ? true : false;
                vm.selectedFam = obj.fam == 'Y' ? true : false;
                vm.selectedTrainingProgramDetails = null;
                vm.startTimeTraining = obj.startTime;
              }else{
                if(vm.selectedType === 'FLIGHT'){
                  vm.selectedFlightLegIdList.splice(index,1);
                }else if (vm.selectedType == 'TRAINING'){
                   vm.selectedTrainingSlotIdList.splice(index,1);
                }
              }
              getTrainingProgramDetails();
              setSelectedTrainingProgramDetails();
              setSelectedTraining();
              getTrainerTrainee();
              getTrainerTraineeForSelectedFlightOrTraining();
            }
        };

        vm.onUpdateTrainingDetails = function () {

//                	 if (vm.selectedTrainingProgram == null || vm.selectedTrainingProgramDetails == null) {
//                		 return;
//                	 }
          var selectedFlightDetail = null;
          if(vm.selectedFlightLegId !=null){
            selectedFlightDetail = _.find(vm.blockDetails.adaptedFlightEventDetails, {id: vm.selectedFlightLegId});
          }

          if(!!selectedFlightDetail){
            var flightStartDateTime = selectedFlightDetail.startTime;
            var flightEndDateTiem = selectedFlightDetail.endTime;
            if(moment(flightStartDateTime,"DD/MM/YYYY HH:mm").isBefore(moment(vm.blockDetails.checkInDateStr+" "+vm.blockDetails.checkInTimeStr,"DD/MM/YYYY HH:mm"))){
              MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_01);
              return false;
            }
            else if(moment(vm.blockDetails.checkoutDateStr+" "+vm.blockDetails.checkoutTimeStr,"DD/MM/YYYY HH:mm").isBefore(moment(flightEndDateTiem,"DD/MM/YYYY HH:mm"))){
              MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_02);
              return false;
            }
            else{
              var continueOveride = false;
              updateTrainingDetails(continueOveride);
            }

            getTrainerTrainee();
          }

        };

        function isExistInList(crew){
          var selectedCrew = null;
          var selectedCrew = _.find(vm.selectedCrewList, {crewProfileId: crew.crewProfileId});
          return (selectedCrew != null) ? true : false;
        }

        function removeElementFromCrewList(crew){
          if(isExistInList(crew)){
            vm.selectedCrewList.splice(vm.selectedCrewList.indexOf(crew), 1);
          }
        }

        function isExistInProfileList(crewProfileId){
          return (vm.crewProfileIds.indexOf(crewProfileId) >= 0) ? true : false;
        }

        function removeElementFromCrewProfileList(crewProfileId){
            vm.crewProfileIds.splice(vm.crewProfileIds.indexOf(crewProfileId), 1);
        }

        function removeElementFromCrewIdList(crewId){
            vm.crewIds.splice(vm.crewIds.indexOf(crewId), 1);

        }

        function removeElementFromCrewHubList(crewHub){
            vm.crewHubs.splice(vm.crewHubs.indexOf(crewHub), 1);
        }

        function removeElementFromCrewProfileMap(crewProfileId){
          delete vm.crewProfileIdToTypeMap[crewProfileId];
        }

        vm.selectCrewCheckBox = function(crew){
          if(!isExistInList(crew) && crew.isSelected){
            vm.selectedCrewList.push(crew);
          }else if(!crew.isSelected){
            removeElementFromCrewList(crew);
          }

          if(!isExistInProfileList(crew.crewProfileId) && crew.isSelected){
            vm.crewProfileIds.push(crew.crewProfileId);
            vm.crewIds.push(crew.crewId);
            vm.crewProfileIdToTypeMap[crew.crewProfileId] = crew.crewType;
            // Extract hub code: otherHub takes precedence over crewHub for multi-hub support
            var hubCode = crew.otherHub || crew.crewHub || null;
            vm.crewHubs.push(hubCode);
          }else if(!crew.isSelected){
            removeElementFromCrewProfileList(crew.crewProfileId);
            removeElementFromCrewIdList(crew.crewId);
            removeElementFromCrewProfileMap(crew.crewProfileId);
            var hubCode = crew.otherHub || crew.crewHub || null;
            removeElementFromCrewHubList(hubCode);
          }
        }

        vm.selectCrewAllCrew = function(){
          if(vm.isAllCrewSelected){
            angular.forEach(vm.blockDetails.adaptedAssignedCrewDetails, function(crew) {
              vm.selectedCrewList.push(crew);
            });
          }else if(!vm.isAllCrewSelected) {
            angular.forEach(vm.blockDetails.adaptedAssignedCrewDetails, function(crew) {
              removeElementFromCrewList(crew);
            });
          }
        }

        function getSelectedCrewList(){
          var list = [];
          angular.forEach(vm.selectedCrewList, function(crew){
            if (crew.trainrerTraineeTypeCode === 'TNE') {
              list.push(_.find(vm.blockDetails.assignedCrewDetailDTOs, {crewProfileId: crew.crewProfileId}));
            }
          });

          if(list.length == 0){
            if (vm.selectedCrew.trainrerTraineeTypeCode === 'TNE') {
              list.push(vm.selectedCrew);
            }
          }
          return list;
        }

        vm.updateResult = function () {
          var crewList = getSelectedCrewList();
          if(vm.selectedFlightLegIdList.length == 0 && vm.selectedTrainingSlotIdList.length > 0){
            angular.forEach(vm.selectedTrainingSlotIdList, function(selectedTrainingSlotId){
                var selectedTraining =  _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: selectedTrainingSlotId});
              if (selectedTraining != null && selectedTraining.trainingProgStatusCode == 'CANCELLED'){
                MessageService.error('Result update not allowed for cancelled trainings');
              }else{
                CrewingHelper.updateExpiryBlock(
                  selectedTraining,
                  crewList,
                  vm.selectedResult && vm.selectedResult.name,
                  vm.remarks,
                  vm.validationNo,
                  function(updateResponse){
                    if(updateResponse.success){
                      vm.selectedCrewList =[];
                      var updated = CrewingHelper.getCrewIdsFromBlockDetails(vm.blockDetails);
                      EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_BLOCK, updated);
                      setPassFailInfo();
                      MessageService.success('Result successfully updated');
                      // Check for other hub crew warnings/failures
                      handleOtherHubCrewResults(updateResponse);
                    }
                  },
                  function(msg){
                    vm.selectedCrewList =[];
                    MessageService.error(msg);
                  }
                );
              }
            });
          }
          if(vm.selectedFlightLegIdList.length > 0 && vm.selectedTrainingSlotIdList.length == 0){
            var selectedFlight = _.find(vm.blockDetails.scheduleFlightLegDetails, {flightLegId: vm.selectedFlightLegId});
            updateFlightExpiryWithWarningHandling(selectedFlight, crewList, null);
          }
        };

        /**
         * Update flight expiry with warning handling and retry capability
         */
        function updateFlightExpiryWithWarningHandling(selectedFlight, crewList, ignoreFlags) {
            // Determine if we have local hub crews in the request
            var hasLocalHubCrews = crewList.some(function(crew) {
                return !crew.otherHub;
            });
            var hasOtherHubCrews = crewList.some(function(crew) {
                return !!crew.otherHub;
            });

            CrewingHelper.updateExpiryFlight(
              selectedFlight,
              crewList,
              vm.selectedResult && vm.selectedResult.name,
              vm.remarks,
              vm.validationNo,
              function(updateResponse){
                if(updateResponse.success){
                  vm.selectedCrewList =[];
                  var updated = CrewingHelper.getCrewIdsFromBlockDetails(vm.blockDetails);
                  EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                  // Show success message only for local hub crews
                  if (hasLocalHubCrews) {
                      MessageService.success('Result successfully updated');
                  }
                  // Check for other hub crew results - pass context for proper messaging
                  handleOtherHubCrewResults(updateResponse, selectedFlight, !hasLocalHubCrews);
                } else if (updateResponse.warnType) {
                  // Handle warning - show confirmation dialog
                  handleExpiryWarning(updateResponse, selectedFlight, crewList);
                } else {
                  vm.selectedCrewList = [];
                  MessageService.error('Update operation unsuccessful');
                }
              },
              function(msg){
                MessageService.error(msg);
              },
              ignoreFlags
            );
        }

        /**
         * Handle expiry warning by showing confirmation dialog
         */
        function handleExpiryWarning(updateResponse, selectedFlight, crewList) {
            var warnType = updateResponse.warnType;
            var crewName = updateResponse.crewProfileName || 'Unknown Crew';
            var messages = [];
            var canRetry = true;

            if (warnType === 'EXPIRY_EXISTS') {
                messages = [
                    'An expiry record already exists for crew: ' + crewName,
                    'Do you want to override the existing expiry record?'
                ];
            } else if (warnType === 'EXPIRY_WARN_EXIST') {
                messages = [
                    'Expiry conflict detected for crew: ' + crewName,
                    'The new expiry date may conflict with an existing record.',
                    'Do you want to continue?'
                ];
            } else if (warnType === 'EXPIRY_DELETE_NO_PRIVILEGE') {
                messages = [
                    'You do not have privilege to modify expiry records for crew: ' + crewName
                ];
                canRetry = false;
            } else {
                messages = [
                    'Warning for crew: ' + crewName,
                    updateResponse.warnType,
                    'Do you want to continue?'
                ];
            }

            if (canRetry) {
                var param = {
                    title: 'Confirmation',
                    messages: messages
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, function(result) {
                    if (result === 'YES') {
                        // Retry with ignore flags
                        var ignoreFlags = {
                            ignoreExpiry: true,
                            ignoreExpiryProcess: true,
                            ignoreObjectExpiryExists: true,
                            ignoreObjectExpiryProcess: true
                        };
                        updateFlightExpiryWithWarningHandling(selectedFlight, crewList, ignoreFlags);
                    } else {
                        vm.selectedCrewList = [];
                        MessageService.warning('Update operation cancelled');
                    }
                });
            } else {
                vm.selectedCrewList = [];
                MessageService.error(messages[0]);
            }
        }


        function handleOtherHubCrewResults(updateResponse, selectedFlight, onlyOtherHubCrews) {
            if (!updateResponse.otherHubCrewResults || updateResponse.otherHubCrewResults.length === 0) {
                // If only other hub crews were selected but no results, show generic success
                if (onlyOtherHubCrews) {
                    MessageService.success('Result successfully updated');
                }
                return;
            }

            var retryableCrews = [];
            var hardFailures = [];
            var successCount = 0;

            _.forEach(updateResponse.otherHubCrewResults, function(result) {
                if (result.success) {
                    successCount++;
                } else {
                    var crewInfo = 'Crew ' + (result.crewId || 'Unknown') + ' (Hub: ' + (result.targetHub || 'Unknown') + ')';

                    if (result.errorCode === 'EXPIRY_EXISTS' || result.errorCode === 'EXPIRY_WARN_EXIST') {
                        // Retryable warning - collect for confirmation dialog
                        retryableCrews.push({
                            crewId: result.crewId,
                            crewProfileId: result.crewProfileId,
                            targetHub: result.targetHub,
                            errorCode: result.errorCode,
                            message: result.errorCode === 'EXPIRY_EXISTS'
                                ? crewInfo + ': Expiry record already exists'
                                : crewInfo + ': Expiry conflict detected'
                        });
                    } else if (result.errorCode === 'EXPIRY_DELETE_NO_PRIVILEGE') {
                        hardFailures.push(crewInfo + ': No privilege to delete expiry record.');
                    } else if (result.errorCode === 'GRPC_ERROR') {
                        hardFailures.push('CES-500: System error occurred. Please contact administrator.');
                    } else {
                        hardFailures.push(crewInfo + ': ' + (result.message || 'Update failed.'));
                    }
                }
            });

            // Show success count if any succeeded
            if (successCount > 0) {
                MessageService.success(successCount + ' other hub crew(s) updated successfully.');
            }

            // Show hard failures (non-retryable)
            if (hardFailures.length > 0) {
                _.forEach(hardFailures, function(failure) {
                    MessageService.error(failure);
                });
            }

            // Show confirmation dialog for retryable warnings
            if (retryableCrews.length > 0) {
                showOtherHubRetryConfirmation(retryableCrews, selectedFlight);
            }
        }

        /**
         * Show confirmation dialog for other hub crews with retryable warnings
         */
        function showOtherHubRetryConfirmation(retryableCrews, selectedFlight) {
            var messages = ['The following other hub crews have warnings:'];

            _.forEach(retryableCrews, function(crew) {
                messages.push(crew.message);
            });

            messages.push('');
            messages.push('Do you want to override and continue?');

            var param = {
                title: 'Other Hub Crew Confirmation',
                messages: messages
            };

            PopupManager.openModal('CONFIRM_DIALOG', param, function(result) {
                if (result === 'YES') {
                    retryOtherHubCrewsUpdate(retryableCrews, selectedFlight);
                } else {
                    MessageService.warning('Update cancelled for ' + retryableCrews.length + ' other hub crew(s).');
                }
            });
        }


        function retryOtherHubCrewsUpdate(retryableCrews, selectedFlight) {
            // Build crew list with only the failed other hub crews
            var crewList = [];
            _.forEach(retryableCrews, function(crew) {
                // Find the crew in assignedCrewTrainingDetails to get full info
                var crewDetail = _.find(selectedFlight.assignedCrewTrainingDetails, function(item) {
                    return item.crewId === crew.crewId ||
                           (item.crewProfileId && item.crewProfileId.toString() === crew.crewProfileId.toString());
                });

                if (crewDetail) {
                    crewList.push({
                        crewProfileId: crewDetail.crewProfileId,
                        crewId: crew.crewId,
                        otherHub: crew.targetHub
                    });
                }
            });

            if (crewList.length === 0) {
                MessageService.error('Could not find crew details for retry.');
                return;
            }

            var ignoreFlags = {
                ignoreExpiry: true,
                ignoreExpiryProcess: true,
                ignoreObjectExpiryExists: true,
                ignoreObjectExpiryProcess: true
            };

            CrewingHelper.updateExpiryFlight(
                selectedFlight,
                crewList,
                vm.selectedResult && vm.selectedResult.name,
                vm.remarks,
                vm.validationNo,
                function(retryResponse) {
                    if (retryResponse.success) {
                        MessageService.success('Other hub crew(s) updated successfully.');
                        // Refresh the schedule
                        var updated = CrewingHelper.getCrewIdsFromBlockDetails(vm.blockDetails);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                        // Check if there are still any failures in retry
                        if (retryResponse.otherHubCrewResults) {
                            var stillFailed = retryResponse.otherHubCrewResults.filter(function(r) {
                                return !r.success;
                            });
                            if (stillFailed.length > 0) {
                                _.forEach(stillFailed, function(f) {
                                    MessageService.error('Crew ' + f.crewId + ' (Hub: ' + f.targetHub + '): ' + (f.message || 'Update failed'));
                                });
                            }
                        }
                    } else {
                        MessageService.error('Retry failed: ' + (retryResponse.message || 'Unknown error'));
                    }
                },
                function(msg) {
                    MessageService.error('Retry failed: ' + msg);
                },
                ignoreFlags
            );
        }

        vm.upDateTrainerTrainee = function () {
            updateTrainerTrainee();
          /*if(!!vm.selectedCrewRole){
        	  updateTrainerTrainee();
            setTrainingCheckInTimes();
            if(vm.selectedCrewRole.trainerTypeCode == 'TNE') {
              updateCheckInTime(false);
            } else {
              updateTrainerTrainee();
            }
          }*/
        };

        function updateTrainerTrainee(){

          var crew = _.find(vm.blockDetails.assignedCrewDetailDTOs, {crewProfileId: vm.selectedCrewProfileId});
          if(!!!vm.selectedTrainingProgramDetails){
        	  MessageService.warning("Please Select Training Program Detail to Proceed Updating Trainer Trainee Types");
        	  vm.blockDetails.openBlockDetailsPanel;
        	  return;
          }
          vm.selectedType = null;
          if(vm.selectedFlightLegIdList.length > 0 && vm.selectedTrainingSlotIdList.length > 0){
            MessageService.error(MessageService.MESSAGES.CREWING.MULTIPLE_SELECTED_TYPES_TRAINER_TRAINEE_UPDATE);

          }else if(vm.selectedFlightLegIdList.length == 0 && vm.selectedTrainingSlotIdList.length > 0){
            vm.selectedType = 'TRAINING';
          }else if(vm.selectedFlightLegIdList.length > 0 && vm.selectedTrainingSlotIdList.length == 0){
            vm.selectedType = 'FLIGHT';
          }

          if(vm.selectedType == 'FLIGHT' || vm.selectedType == 'TRAINING'){
            var param = {
                trainingProgramId: vm.selectedTrainingProgram.trainingProgramId,
                trainingProgramDetailId: vm.selectedTrainingProgramDetails.trainingProgramDetailId,
                pic: vm.selectedPic,
                trainingSlotId: vm.selectedTrainingSlotId,
                crewProfileId: vm.selectedCrewProfileId,
                crewHub: crew.crewHub,
                crewId: crew.crewId,
                type: vm.selectedType == 'TRAINING' ? 'SLOT' : 'FLIGHT',
                assignedAsType: vm.selectedCrewRole != null ? vm.selectedCrewRole.trainerTypeCode : null,
                assignedAsCourse:vm.selectedCrewCourse != null ? vm.selectedCrewCourse.courseId : null,
                crewScheduleBlockId: vm.blockDetails.crewScheduleBlockId,
                version: getVersion(crew),
                crewScheduleTrainingSlotId : vm.selectedType == 'TRAINING' ? getSlotId(vm.selectedTrainingSlotId) : null,
                selectedCrewSchedTrainingSlotIds : vm.selectedType == 'TRAINING' ? getCrewSchTrainingSlotIds(vm.selectedTrainingSlotIdList) : null,
                crewSchdFlightLegId: crew && crew.crewSchdFlightLegId,
                selectedFlightLegId: vm.selectedFlightLegId,
                isTraining : vm.blockDetails.isTraining,
                courseStartDate : vm.blockDetails.checkInDateStr,
                courseStartTime : vm.blockDetails.checkInTimeStr,
                crewProfileIds: vm.crewProfileIds,
                crewIds: vm.crewIds,
                crewHubs: vm.crewHubs,
                selectedFlightLegIds: vm.selectedFlightLegIdList,
                crewProfileIdToTypeMap:vm.crewProfileIdToTypeMap
              };


              CrewingHelper.updateTrainerTrainee(param,
                function (updateResponse) {
                  if(updateResponse.success){
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.REFRESH);

                    //var updated = CrewingHelper.getCrewIdsFromBlockDetails(vm.blockDetails);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_BLOCK, vm.blockDetails);
                    MessageService.success('Result successfully updated.');
                    vm.status.sixthOpen = true;
                    vm.status["isAvailableTrainings"] = false;
                    vm.status["isTrainingDetails"] = true;
                    vm.crewProfileIds = [];
                    vm.crewIds = [];
                    vm.crewHubs = [];
                    vm.crewProfileIdToTypeMap={};
                    crew.trainrerTraineeType = vm.selectedCrewRole.trainerTypeDesc;
                    crew.trainrerTraineeTypeCode = vm.selectedCrewRole.trainerTypeCode;
                    vm.onCrewClick(vm.selectedCrewProfileId, crew);
                  }

                  if(updateResponse.warnings && updateResponse.warnings.length > 0){
                    MessageService.error(updateResponse.warnings[0]);
                  }

                },
                function (msg) {
                  MessageService.error(msg);
                }
              );
          }
        }

        function setTrainingCheckInTimes(){

          if(vm.selectedTrainingProgram == null ){
            vm.checkInDateStr = null;
            vm.checkInTimeStr = null;
            return;
          }

          var checkInDate = moment(vm.blockDetails.actualBlockStartDate + " " +vm.blockDetails.actualBlockStartTime,
            "DD/MM/YYYY HH:mm");

          checkInDate.add( ( -1 * vm.selectedTrainingProgram.defaultCheckIn ), 'minutes');

          var checkInDateStr = checkInDate.format('DD/MM/YYYY');
          var checkInTimeStr = checkInDate.format('HH:mm');
          vm.checkInDateStr = checkInDateStr;
          vm.checkInTimeStr = checkInTimeStr;
        }

        function getVersion(crew) {
          var version = null;
          if (!!crew) {
            version = (vm.blockDetails.isTraining) ? crew.crewSchdTrainingSlotVersion : crew.crewSchdFlightLegVersion;
          }
          return version;
        }

        function getSlotId(trainingSlotId) {
          var slot = _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: trainingSlotId});
          var crew = _.find(slot.assignedCrewTrainingDetails, {crewProfileId: vm.selectedCrewProfileId});
          return crew.crewScheduleTrainingSlotId;
        }

        function getCrewSchTrainingSlotIds(selectedTrainingSlotIdList) {
            var CrewSchTrainingSlotIds = [];
            angular.forEach(selectedTrainingSlotIdList, function(selectedTrainingSlotId) {
                var slot = _.find(vm.blockDetails.scheduleTrainingDetails, {trainingSlotId: selectedTrainingSlotId});
                var crew = _.find(slot.assignedCrewTrainingDetails, {crewProfileId: vm.selectedCrewProfileId});
                CrewSchTrainingSlotIds.push(crew.crewScheduleTrainingSlotId);
            });
            return CrewSchTrainingSlotIds;
        }

        function onCloseRegulationPopupForPairing(params) {
          if (!!params) {
            onUpdate(true);
          }
        }

        function editPairingResponseAction(editParingResponse) {
          if (editParingResponse.success) {
            localStorage.setItem("crewList", vm.blockDetails.crew.crewId);
            MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
            if (editParingResponse.otherBlockIllegal) {
              MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
            }
            var updated = CrewingHelper.getCrewIdsFromBlockDetails(vm.blockDetails);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
            //SlideInPanelService.toggle('crewing.right.panel', vm.model.blockDetails);
          } else if (!!editParingResponse) {
            if (!!editParingResponse.regulationMap) {
              var regulationDetailParam = {
                regulationMap: editParingResponse.adaptedRegulationMap,
                onAcceptPassBackParam: editParingResponse
              };
              PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
            }
          }
        }

        function getTrainerTraineeForSelectedFlightOrTraining() {
          //get all the assigned crew and adjust trainer trainee according to the flightleg assignedtrainingdetails
          var selectedFlightLegTrainerTraineeCrew = [];
          angular.forEach(vm.blockDetails.flightTrainingAssignedCrew, function (assignedCrew) {
            if (assignedCrew.flightLegId === vm.selectedFlightLegId) {
              selectedFlightLegTrainerTraineeCrew = assignedCrew.crewList;
            }
          });

          angular.forEach(vm.blockDetails.adaptedAssignedCrewDetails, function (crew) {
            var isCrewCaptured = 'N';
            if (selectedFlightLegTrainerTraineeCrew.length === 0 ) {
              crew.trainrerTraineeType = null;
              crew.trainrerTraineeTypeCode = null;
            }
            else {
              for (var traineeTrainerCrew = 0; traineeTrainerCrew < selectedFlightLegTrainerTraineeCrew.length; traineeTrainerCrew++) {
                if (crew.crewProfileId === selectedFlightLegTrainerTraineeCrew[traineeTrainerCrew].crewProfileId) {
                  crew.trainrerTraineeType = selectedFlightLegTrainerTraineeCrew[traineeTrainerCrew].trainingCategory;
                  crew.trainrerTraineeTypeCode = selectedFlightLegTrainerTraineeCrew[traineeTrainerCrew].trainingCategory === 'TRAINEE' ? 'TNE' : selectedFlightLegTrainerTraineeCrew[traineeTrainerCrew].trainingCategory;
                  isCrewCaptured = 'Y';
                } else if (isCrewCaptured !== 'Y'){
                  crew.trainrerTraineeType = null;
                  crew.trainrerTraineeTypeCode = null;
                }
              }
            }

          });

        }

        vm.clickOnCrewTitle = function (showingCrewProfile) {
          vm.showingCrewProfile = !showingCrewProfile;
          if(vm.showingCrewProfile){
            vm.crew_detail_section_width = 370;
          } else {
            vm.crew_detail_section_width = 0;
          }

         vm.showingCrewProfilePanel({isShowing: !showingCrewProfile});
        };

        vm.clickOnCrewNavigation= function(option){
          vm.crewNavigation({'type':option})
        };

        vm.setCrewId = function(isHide, crewId){
          if(!isHide){
            return '('+ crewId +')';
          }
          return '';
        };

        vm.onCrewClick = function (crewProfileId,crew) {
          vm.selectedCrewProfileId = crewProfileId;
          vm.selectedCrew = crew;
          vm.showTrainingPassPanel = false;
          getTrainerTrainee();
          getTrainerTraineeCourses();
          setPassFailInfo();

        };

        vm.clickOnAccordion  = function(selectedItem, event){
          /* vm.status = {
           isFirstOpen: false,
           isNoteOpen:false,
           isSecondOpen:false,
           fourthOpen:false,
           fifthOpen:false,
           sixthOpen:false,
           isSevenOpen:false
            };*/
          vm.status[selectedItem] = !vm.status[selectedItem];
          vm.status["isAvailableTrainings"] = true;
          vm.status["isTrainingDetails"] = false;
        };

        vm.clickOnFlightBlockButtons = function(selectedItem, event){
          if (selectedItem === "flightData"){
            vm.status["isFlightData"] = true;
            vm.status["isBlockData"] = false;
            vm.status["isTakeOffLandingData"] = false;
          }else if (selectedItem === "blockData"){
            vm.status["isBlockData"] = true;
            vm.status["isFlightData"] = false;
            vm.status["isTakeOffLandingData"] = false;
          }else if (selectedItem === "takeOffLandingData"){
            vm.status["isBlockData"] = false;
            vm.status["isFlightData"] = false;
            vm.status["isTakeOffLandingData"] = true;
          }
        };

        vm.clickOnTrainingButtons = function(selectedItem, event){
          if (selectedItem === "trainingDetails"){
            vm.status["isTrainingDetails"] = true;
            vm.status["isAvailableTrainings"] = false;
          }else if (selectedItem === "availableTrainings"){
            vm.status["isAvailableTrainings"] = true;
            vm.status["isTrainingDetails"] = false;
          }
        };

        vm.navigateToCrewProfile = function () {
          vm.onNavigateCrewProfile();
        };

        vm.creditHours = function () {
          vm.openCreditHours();
        }

      },
      bindings: {
        crewDetails:'<',
        viewMode:'<',
        crewPublishSchedule:'<',
        airportExclusion:'<',
        crewExclusion:'<',
        crewNotes:'<',
        addEditNotes:'&',
        noteModel:'<',
        warnings:'=',
        noteButtonLabel:'<',
        loadEditNoteData:'&',
        deleteCrewNotes:'&',
        blockDetails:'<',
        crewNavigation:'&',
        isNoteAvailable:'<',
        onNavigateCrewProfile:'&',
        showingCrewProfilePanel:'&',
        showingCrewProfile:'=',
        openCreditHours:'&',
        showTrainingStages:'&',
        syncTrainingStages:'&',
        scheduleFromDate:'<',
        scheduleToDate:'<'
      }
    });
})();
